export default __webpack_public_path__ + "static/Experiencia y Casos de exito SOLIN vPW-d902fe102632c2a03259180af371e879.pdf";